// Swiper's cards effect needs a minimum number of slides for loop mode to work
// correctly (fewer and it silently stalls or jumps). Below this, we duplicate
// the real slides in the DOM so loop has enough to work with.
const EFFECT_CARDS_MIN_LOOP_SLIDES = 9;

// On phones the active card nearly fills the width, so large offsets/rotations push
// the stacked cards off-screen. Cap them below this breakpoint.
const EFFECT_CARDS_MOBILE_QUERY = window.matchMedia('(max-width: 749px)');
const EFFECT_CARDS_MOBILE_MAX_OFFSET = 8;
const EFFECT_CARDS_MOBILE_MAX_ROTATE = 3;

function numberOr(value, fallback) {
  const number = Number(value);
  return value === undefined || value === '' || Number.isNaN(number) ? fallback : number;
}

function cardsEffectParams(el) {
  const perSlideOffset = numberOr(el.dataset.perSlideOffset, 8);
  const perSlideRotate = numberOr(el.dataset.perSlideRotate, 2);
  const isMobile = EFFECT_CARDS_MOBILE_QUERY.matches;
  return {
    rotate: el.dataset.rotate === 'true',
    slideShadows: el.dataset.slideShadows === 'true',
    perSlideOffset: isMobile ? Math.min(perSlideOffset, EFFECT_CARDS_MOBILE_MAX_OFFSET) : perSlideOffset,
    perSlideRotate: isMobile ? Math.min(perSlideRotate, EFFECT_CARDS_MOBILE_MAX_ROTATE) : perSlideRotate,
  };
}

function syncActiveVideo(el) {
  el.querySelectorAll('.effect-cards__video video').forEach((video) => video.pause());
  const activeVideo = el.querySelector('.swiper-slide-active .effect-cards__video video');
  if (activeVideo && activeVideo.hasAttribute('autoplay')) {
    activeVideo.play().catch(() => {});
  }
}

function padSlidesForLoop(el) {
  const wrapper = el.querySelector('.swiper-wrapper');
  const originalSlides = Array.from(wrapper.children);
  const realCount = originalSlides.length;
  if (realCount < 2) return;

  const target = Math.ceil(EFFECT_CARDS_MIN_LOOP_SLIDES / realCount) * realCount;
  let i = 0;
  while (wrapper.children.length < target) {
    const clone = originalSlides[i % realCount].cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('data-ec-clone', 'true');
    clone.removeAttribute('data-shopify-editor-block-id');
    clone.querySelectorAll('[data-shopify-editor-block-id]').forEach((node) => node.removeAttribute('data-shopify-editor-block-id'));
    clone.querySelectorAll('a, button').forEach((node) => node.setAttribute('tabindex', '-1'));
    wrapper.appendChild(clone);
    i++;
  }
}

function unpadSlides(el) {
  el.querySelectorAll('[data-ec-clone]').forEach((node) => node.remove());
}

function initEffectCards(root) {
  root.querySelectorAll('.effect-cards').forEach((el) => {
    if (el.swiperInstance || typeof Swiper === 'undefined') return;

    const loopRequested = el.dataset.loop === 'true';
    if (loopRequested) padSlidesForLoop(el);

    const slideCount = el.querySelectorAll('.swiper-slide').length;
    const loop = loopRequested && slideCount > 1;
    const autoplay = el.dataset.autoplay === 'true';
    const autoplaySpeed = Number(el.dataset.autoplaySpeed) || 4000;
    const pauseOnHover = el.dataset.pauseOnHover === 'true';
    const controls = el.parentElement;
    const paginationEl = controls.querySelector('.swiper-pagination');
    const nextEl = controls.querySelector('.swiper-button-next');
    const prevEl = controls.querySelector('.swiper-button-prev');

    el.swiperInstance = new Swiper(el, {
      effect: 'cards',
      grabCursor: el.dataset.grabCursor === 'true',
      speed: Number(el.dataset.speed) || 300,
      initialSlide: Number(el.dataset.initialSlide) || 0,
      loop,
      keyboard: el.dataset.keyboard === 'true' ? { enabled: true } : false,
      mousewheel: el.dataset.mousewheel === 'true',
      cardsEffect: cardsEffectParams(el),
      autoplay: autoplay
        ? {
            delay: autoplaySpeed,
            disableOnInteraction: false,
            pauseOnMouseEnter: pauseOnHover,
          }
        : false,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
            type: el.dataset.paginationType || 'bullets',
            dynamicBullets: loop && el.dataset.paginationType === 'bullets',
          }
        : false,
      navigation: nextEl && prevEl ? { nextEl, prevEl } : false,
      on: {
        init() {
          syncActiveVideo(el);
        },
        slideChange() {
          syncActiveVideo(el);
        },
      },
    });
  });
}

// Re-apply offset/rotation when crossing the mobile breakpoint (rotation, resize).
EFFECT_CARDS_MOBILE_QUERY.addEventListener('change', () => {
  document.querySelectorAll('.effect-cards').forEach((el) => {
    const swiper = el.swiperInstance;
    if (!swiper) return;
    Object.assign(swiper.params.cardsEffect, cardsEffectParams(el));
    swiper.setTranslate(swiper.translate);
  });
});

function destroyEffectCards(root) {
  root.querySelectorAll('.effect-cards').forEach((el) => {
    if (el.swiperInstance) {
      el.swiperInstance.destroy(true, true);
      el.swiperInstance = null;
    }
    unpadSlides(el);
  });
}

document.addEventListener('DOMContentLoaded', () => initEffectCards(document));

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initEffectCards(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyEffectCards(event.target));
}
